import React from 'react';
import { Typography, Box, Button, Stack, Chip } from '@mui/material';

function ReviewQuestionCard({ question, questionNumber }) {
  return (
    <Box
      sx={{
        mb: 4,
        p: { xs: 2, md: 3 },
        borderRadius: 1,
        border: '1px solid rgba(36,91,89,0.12)',
        backgroundColor: 'rgba(246,248,245,.75)',
      }}
    >
      <Stack spacing={2}>
        <Stack direction="row" spacing={2} alignItems="center" flexWrap="wrap">
          <Chip label={`Pytanie ${questionNumber}`} size="small" sx={{ bgcolor: 'rgba(36,91,89,.1)', color: 'primary.main', fontWeight: 700 }} />
          <Typography variant="h6" component="h4">
            {question.question}
          </Typography>
        </Stack>
        {question.image && (
          <Box sx={{ mt: 1 }}>
            <img
              src={`/assets/${question.image}`}
              alt="question illustration"
              style={{ maxWidth: '100%', height: 'auto', borderRadius: 12 }}
            />
          </Box>
        )}
        <Stack spacing={1}>
          {question.answers.map((answer, i) => (
            <Button
              key={i}
              variant={i === question.correctAnswer ? 'contained' : 'outlined'}
              color={i === question.correctAnswer ? 'success' : 'primary'}
              fullWidth
              sx={{
                justifyContent: 'flex-start',
                textAlign: 'left',
                borderRadius: 1,
                borderColor: i === question.correctAnswer ? 'success.main' : 'rgba(36,91,89,0.2)',
              }}
            >
              {answer}
            </Button>
          ))}
        </Stack>
      </Stack>
    </Box>
  );
}

export default ReviewQuestionCard;
